import { t } from 'i18next';
import React from 'react';
import { createOptionsList } from '../../../services/common/miscUtils';
import { getMinBirthDate } from '../../../services/common/validation';
import { DatePickerFormField } from '../../Fieldset/DatePickerFormField';
import { EircodeFormField } from '../../Fieldset/EircodeFormField';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';
import { CountyEnum } from '../../../types/countyEnum';

export const createFormInputs = (formTranslationKey: string, disableAllFormControls: boolean) => {
  return {
    addressLine1: () => (
      <TextInputFormField
        fieldName="addressLine1"
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.${'addressLine1'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'addressLine1'}.placeholder`}
      />
    ),
    addressLine2: () => (
      <TextInputFormField
        fieldName="addressLine2"
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.${'addressLine2'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'addressLine2'}.placeholder`}
      />
    ),
    addressLine3: () => (
      <TextInputFormField
        fieldName="addressLine3"
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.${'addressLine3'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'addressLine3'}.placeholder`}
      />
    ),
    eirCode: () => (
      <EircodeFormField
        fieldName="eirCode"
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.${'eirCode'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'eirCode'}.placeholder`}
      />
    ),
    town: () => (
      <TextInputFormField
        fieldName="town"
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.${'town'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'town'}.placeholder`}
      />
    ),
    county: () => (
      <SelectFormField
        fieldName="county"
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.${'county'}.label`}
        optionList={createOptionsList(CountyEnum, formTranslationKey, 'county')}
      />
    ),
    residentialStatus: () => (
      <SelectFormField
        fieldName="residentialStatus"
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.${'residentialStatus'}.label`}
        optionList={[
          { label: t('formControls:select.noSelection'), value: '' },
          {
            label: t(`${formTranslationKey}:fields.${'residentialStatus'}.options.owner`),
            value: 'owner',
          },
          {
            label: t(`${formTranslationKey}:fields.${'residentialStatus'}.options.privateTenant`),
            value: 'privateTenant',
          },
          {
            label: t(`${formTranslationKey}:fields.${'residentialStatus'}.options.livingWithParents`),
            value: 'livingWithParents',
          },
        ]}
      />
    ),
    timeAtAddressFrom: (timeAtAddressTo: string) => (
      <DatePickerFormField
        fieldName="timeAtAddressFrom"
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.${'timeAtAddressFrom'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'timeAtAddressFrom'}.placeholder`}
        minDate={getMinBirthDate()}
        maxDate={timeAtAddressTo || new Date()}
      />
    ),
    timeAtAddressTo: () => (
      <DatePickerFormField
        fieldName="timeAtAddressTo"
        isDisabled
        labelTranslationKey={`${formTranslationKey}:fields.${'timeAtAddressTo'}.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.${'timeAtAddressTo'}.placeholder`}
      />
    ),
  };
};
